import { render, staticRenderFns } from "./PriceTimeComponent.vue?vue&type=template&id=5a43d483"
import script from "./PriceTimeComponent.vue?vue&type=script&lang=js"
export * from "./PriceTimeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports